import React from 'react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

const NetworkStatus = () => {
  const networkStatus = useNetworkStatus();

  const getServiceIcon = (service) => {
    switch (service) {
      case 'ethereum':
        return 'fas fa-ethereum';
      case 'snapshot':
        return 'fas fa-vote-yea';
      case 'ipfs':
        return 'fas fa-cube';
      case 'ens':
        return 'fas fa-signature';
      default:
        return 'fas fa-circle';
    }
  };

  const getServiceName = (service) => {
    switch (service) {
      case 'ethereum':
        return 'Ethereum Mainnet';
      case 'snapshot':
        return 'Snapshot';
      case 'ipfs':
        return 'IPFS';
      case 'ens':
        return 'ENS';
      default:
        return service;
    }
  };

  const getServiceUrl = (service) => {
    switch (service) {
      case 'ethereum':
        return 'https://etherscan.io';
      case 'snapshot':
        return 'https://snapshot.org';
      case 'ipfs':
        return 'https://ipfs.io';
      case 'ens':
        return 'https://app.ens.domains';
      default:
        return '#';
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-lg">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-dominant flex items-center gap-2">
          <i className="fas fa-network-wired"></i>
          Network Status
        </h3>
        <button 
          onClick={() => window.location.reload()}
          className="text-xs text-secondary hover:text-dominant transition-colors flex items-center gap-1"
          title="Refresh status"
        >
          <i className="fas fa-sync-alt"></i>
          Refresh
        </button>
      </div>
      
      <div className="space-y-3">
        {Object.entries(networkStatus).map(([service, status]) => (
          <div key={service} className="flex justify-between items-center">
            <span className="text-gray-600 flex items-center gap-2">
              <i className={getServiceIcon(service)}></i>
              {getServiceName(service)}
            </span>
            
            <div className="flex items-center gap-2">
              {status.loading ? (
                <>
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
                  <span className="text-xs text-gray-500">Checking...</span>
                </>
              ) : status.online ? (
                <a 
                  href={getServiceUrl(service)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-green-600 hover:text-green-700 transition-colors group"
                  title="Click to test"
                >
                  <div className="w-2 h-2 bg-green-500 rounded-full group-hover:animate-pulse"></div>
                  <span className="text-xs">Online</span>
                </a>
              ) : (
                <div className="flex items-center gap-2 text-red-600" title={status.error}>
                  <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                  <span className="text-xs">Offline</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {/* Status Summary */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600">Last checked:</span>
          <span className="text-gray-500">{new Date().toLocaleTimeString()}</span>
        </div>
        {Object.values(networkStatus).some(s => s.error) && (
          <div className="mt-2 text-xs text-orange-600">
            <i className="fas fa-exclamation-triangle mr-1"></i>
            Some services may be experiencing issues
          </div>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;